import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addPartner, deletePartner, loadPartner, submitPartners } from '../../../actions/room';
import { useForm } from '../../../hooks/useForm';

export const Crear = () => {
    const cliente = useSelector(state => state.client);
    const pagos = useSelector(state => state.payments);
    const {sinHabitacion} = useSelector(state => state.rooms);
    const [huespedes, setHuespedes] = useState([]);
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(loadPartner());
    }, [dispatch]);

    const [{clienteSelect}, handleInputChange, reset] = useForm({
        clienteSelect: ''
    });

    const handleAddParner = () => {
        if(clienteSelect){
            setHuespedes([
                ...huespedes, 
                {
                    ...sinHabitacion.find(cliente => cliente.folio === clienteSelect)
                }
            ]);
            dispatch(deletePartner(clienteSelect))
        }
        reset();
    }

    const handleRemoveParner = async (folio) => {
        await dispatch(addPartner(huespedes.find(cliente => cliente.folio === folio)))
        setHuespedes([
            ...huespedes.filter(cliente => cliente.folio !== folio)
        ]);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch( submitPartners(huespedes) );
    }

    return (
        <div>
            <h5>Podras encontrar y agregar al adulto titular de la habitación con quien quieras compartir. <strong></strong></h5>
            {/* <p className="text-warning"> (Conforme vayas agregando integrantes cambiara tu tipo de habitación)</p> */}
            {/* { huespedes.length < 4 && <p className="text-warning"> (Conforme vayas agregando integrantes cambiara tu tipo de habitación)</p> } */}
            {
                huespedes.length < 4 &&
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col">
                                <select 
                                    className="custom-select form-control mr-3"
                                    name="clienteSelect"
                                    onChange={handleInputChange}
                                    value={clienteSelect}
                                >
                                    <option value=""> -- Selecciona -- </option>
                                    {sinHabitacion.map((partner) => <option value={partner.folio} key={partner.folio}>{partner.nombre} {partner.ape_paterno} {partner.ape_materno}</option>)}
                                </select>
                            </div>
                            <div className="col-1 mt-2">
                                <i 
                                    role="button" 
                                    className="text-primary fa fa-plus-circle" 
                                    style={{fontSize: '2.5em'}}
                                    onClick={handleAddParner}
                                ></i>
                            </div>
                        </div>
                    </div>
            }
            
            <table className="table mt-4">
                <thead className="thead-dark">
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Cliente</th>
                        <th scope="col" className="text-right">Pagado</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">1</th>
                        <td>{cliente.nombre} {cliente.ape_paterno} {cliente.ape_materno}</td>
                        <td className="text-right">{ new Intl.NumberFormat("en-US", {style: "currency", currency: "MXN"}).format(pagos.total) }</td>
                    </tr>
                    {huespedes.map((cliente, id) => (
                        <tr key={id}>
                            <th scope="row">{id+2}</th>
                            <td>{cliente.nombre} {cliente.ape_paterno} {cliente.ape_materno}</td>
                            <td className="text-right">
                                <i 
                                    role="button" 
                                    className="text-danger fa fa-minus-circle mr-2" 
                                    style={{fontSize: '2.5em'}}
                                    onClick={() => handleRemoveParner(cliente.folio)}
                                ></i>
                            </td>
                        </tr>
                    ))}
                </tbody>
                <tfoot>
                    <tr>
                        <th colSpan="3" className="text-right"><form onSubmit={handleSubmit}><button type="submit" disabled={huespedes.length < 1  && true} className="btn btn-primary mr-4"> Guardar </button></form></th>
                    </tr>
                </tfoot>
            </table>
            
        </div>
    )
}
